<template>
  <div class="createAcct">
    <navbar></navbar>
    <svgicon icon="design-element" class="design-element"></svgicon>
    <div class="createAcct__wrap">
      <h6 class="createAcct__title signup__title">Welcome back</h6>
      <p class="signup__subtitle mb-4">Sign into Spleet admin account</p>
      <div class="createAcct__form">
        <form action @submit.prevent="submit">
          <div class="error__wrap" v-if="noAccount">
            <span class="error">Invalid email or password</span>
            <svgicon icon="cancel" class="error__icon"></svgicon>
          </div>

          <float-label class="form__input-wrap">
            <input
              type="email"
              v-model="admin.email"
              required
              placeholder="Email"
              class="form__input"
            />
          </float-label>
          <float-label class="form__input-wrap">
            <input
              type="password"
              v-model="admin.password"
              required
              placeholder="Password"
              class="form__input"
            />
          </float-label>
          <button
            :class="{ disabled: !fillAll }"
            type="submit"
            :disabled="!fillAll || loading"
            class="createAcct__ctaBtn"
          >
            <svgicon
              v-if="loading"
              icon="spinner"
              class="button__loader"
            ></svgicon
            >Sign In
          </button>
        </form>
        <!-- <p>Email: admin@spleet.ng</p>
        <p>Password: testPass1!</p> -->

        <router-link to="/forgot-password">
          <p class="forgot-password">Forgot my password</p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import navbar from "./navbar";
import Admin from "../../models/admin";
import VueCookies from "vue-cookies";
export default {
  name: "login",
  components: {
    navbar
  },
  data() {
    return {
      admin: new Admin("", ""),

      loading: false,
      noAccount: false
    };
  },

  methods: {
    submit() {
      this.loading = true;
      if (this.admin.email && this.admin.password) {
        this.$store
          .dispatch("auth/login", this.admin)
          .then(data => {
            this.loading = false;
            if (data.data.statusCode == 200) {
              VueCookies.set("data", data.data.data);
              this.$notification.success({
                message: "Login successful",
                description: "You have successfully loggedin"
              });
              const { redirect } = this.$route.query;
              if (redirect) {
                window.location = redirect;
              } else {
                window.location = "/dashboard";
              }
            }

            if (data.data.message == "Email not verified") {
              const email = this.admin.email;
              localStorage.setItem("email", JSON.stringify(email));
              this.$router.push("/email-not-verified");
            }
          })
          .catch(err => {
            this.loading = false;
            if (err.response.data.statusCode == 401) {
              this.$notification.error({
                message: "Invalid Login",
                description: "Username or password is incorrect"
              });
            }
          });
      }
    }
  },

  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    fillAll() {
      if (this.admin.password == "") {
        if (this.admin.email == "") {
          return false;
        } else {
          return;
        }
      } else if (this.admin.password != "") {
        if (this.admin.email != "") {
          return true;
        } else {
          return;
        }
      } else {
        return undefined;
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/authentication/login.vue